export { default as PageHead } from "./PageHead";
